import React from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { Table, Pagination } from 'antd';
import * as S from './styles';

export default function TablePadrao({ columns, data, paginationConfig = {}, changePage, onRowClick = () => {} }) {
  const loading = useSelector(state => state.app.statusLoadingGrid);

  return (
    <S.ContainerTable>
      <Table
        columns={columns}
        dataSource={data}
        pagination={false}
        loading={loading}
        onRow={record => {
          return { onClick: () => onRowClick(record) };
        }}
      />
      <S.ContainerPagination>
        {paginationConfig?.totalRecords !== undefined ? (
          <S.ContainerTotalItens>Total: {paginationConfig?.totalRecords} itens</S.ContainerTotalItens>
        ) : null}
        {paginationConfig?.totalRecords !== undefined ? (
          <Pagination
            showTitle={false}
            defaultCurrent={1}
            defaultPageSize={10}
            pageSizeOptions={[5, 10, 15, 20, 25]}
            pageSize={paginationConfig?.sizePage}
            current={paginationConfig?.numberPage}
            total={paginationConfig.totalRecords}
            onChange={changePage}
            showSizeChanger={true}
          />
        ) : null}
      </S.ContainerPagination>
    </S.ContainerTable>
  );
}

TablePadrao.propTypes = {
  columns: PropTypes.array,
  data: PropTypes.array,
  paginationConfig: PropTypes.object,
  changePage: PropTypes.func,
};

TablePadrao.defaultProps = {
  // columns: [],
  // data: null,
  // paginationConfig: {},
  // changePage: () => {},
};
